export enum IBaseFileItemStatusEnum {
  Published = 'Published',
  Expired = 'Expired',
}
